import styles from './Badge.module.css'

export type BadgeTone = 'ok' | 'warn' | 'serious' | 'crit' | 'neutral'

/*
 * The mark is a real glyph, not a coloured dot, because status must never be
 * carried by colour alone -- about one man in twelve has a colour vision
 * deficiency, and this tool tells people whether their privacy is leaking.
 * Colour, glyph and label each say the same thing independently.
 */
const GLYPH: Record<BadgeTone, string> = {
    ok: '✓',
    warn: '!',
    serious: '!!',
    crit: '✕',
    neutral: '—',
}

interface BadgeProps {
    tone: BadgeTone
    children: string
}

export default function Badge({ tone, children }: BadgeProps) {
    return (
        <span className={`${styles.badge} ${styles[tone]}`}>
            <span className={styles.glyph} aria-hidden="true">{GLYPH[tone]}</span>
            <span className={styles.label}>{children}</span>
        </span>
    )
}
